import React from 'react';

const Preloader = () => {
  return (
    <div className='preloader-container'>
      <div className='preloader'>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Preloader;
